import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function MemoriesSection ({memoryData, eleRef}){
    // var eleRef = memoryData.eleRef;
    // var memoryData = memoryData.memoryData;
    return(
        <section className="memories-section">
            <div className="section-title">MEMORIES</div>
            <div className="memories-list">
            {memoryData.memories.map((memories, i5) => 
            <div  key={i5} className="memory-post left">
                <a href={service.getRedirectUrl(`/memories/photodetails/${memories.memoryId}`)}>
                <div className="mem-img">
                    <img src={memories.memoryImage.replace("http://", "https://").replace("jpg", "webp")} className="dev_mem_img" onError={(e) => {e.target.src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'}}/>
                </div>
                <div className="mem-name">{memories.userName}</div>
                </a>
            </div>
            )}

            </div>
            {memoryData.search_cnt > memoryData.memories.length &&
            <div className="moreResults dev_v_all" title="MEMORIES" onClick={()=>eleRef.getMoreSearchData(memoryData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
